import Vue from 'vue'
import Vuex from 'vuex'
import Server from './libs/server'
import NAMESPACE from './libs/namespace'
import { saveKeyPrefixFormatter } from './libs/util'
import { BROWSER_SUPPORT_STATUS } from './libs/constant'

import User from './pages/user/store'
import Examination from './pages/examination/store'
import Certification from './pages/certification/store'

Vue.use(Vuex)

const apis = {
  serverTime: [ '/tool/now', 'get' ],
  examinationDay: [ '/exam/examination/day', 'get' ],
  uploadSignature: [ '/upyun/upload/signature', 'get' ],
  searchDiploma: [ '/cert/diploma/search', 'post' ]
}

const store = new Vuex.Store({
  state: {
    title: '',
    now: Date.now(),
    today: '',
    examinationDay: [ 18 ],
    canExam: false,
    browserSupportStatus: BROWSER_SUPPORT_STATUS.NOT_TEST
  },
  mutations: {
    setTitle (state, { title, showTitle = true }) {
      document.title = title || '国际职业技能委员会'
      state.title = showTitle ? title : ''
    },
    setToday (state, { now, examinationDay }) {
      const today = new Date(now)
      state.now = now
      state.today = today.format('yyyy-MM-dd')
      state.examinationDay = process.env.NODE_ENV === 'production' ? examinationDay : examinationDay.concat([ new Date().getDate() ])
      state.canExam = examinationDay.indexOf(today.getDate()) !== -1
    },
    setBrowserSupport (state, support) {
      state.browserSupportStatus = support
    }
  },
  actions: {
    async getExaminationStatus ({ commit }) {
      const [ serverTimeUrl, serverTimeMethod ] = apis.serverTime
      const [ examinationDayUrl, examinationDayMethod ] = apis.examinationDay
      let timestamp
      let examinationDay
      try {
        const [ t, data ] = await Promise.all([
          await Server({
            url: serverTimeUrl,
            method: serverTimeMethod,
            ignoreCode: true
          }),
          await Server({
            url: examinationDayUrl,
            method: examinationDayMethod,
            ignoreCode: true
          })
        ])
        timestamp = t
        if (data && data.data) examinationDay = data.data.examinationDay
      } catch (e) {
        //
      } finally {
        commit('setToday', {
          now: timestamp || Date.now(),
          examinationDay: examinationDay ||  [ 18 ]
        })
      }
    },

    async getUploadSignature (store, saveKeyPrefixs) {
      const [ url, method ] = apis.uploadSignature
      const { data } = await Server({
        url,
        method,
        data: { saveKeyPrefix: saveKeyPrefixFormatter(saveKeyPrefixs) }
      })
      return data
    },

    async searchDiploma (store, { mode, content }) {
      const [ url, method ] = apis.searchDiploma
      const { data } = await Server({
        url,
        method,
        data: { mode, content }
      })
      return data
    }
  }
})

store.registerModule(NAMESPACE.USER, User)
store.registerModule(NAMESPACE.EXAMINATION, Examination)
store.registerModule(NAMESPACE.CERTIFICATION, Certification)

export default store
